export default __webpack_public_path__ + "static/media/towers.bbb050f3.webp";